import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericApiService } from '@pm-ui/core-services';
import { Observable } from 'rxjs';
import { TenancyEndpoints } from '../../config/tenancy/tenancy-end-points';

@Injectable({
  providedIn: 'root'
})
export class TenancyService {

  constructor(private genericApiService: GenericApiService,private _http: HttpClient) { }

  getTenancys<T>(reqModel:any): Observable<any>{        
    return this.genericApiService.post(TenancyEndpoints.GetTenancys, reqModel);
 }

 getTenancyById<T>(id: number): Observable<HttpResponse<T>> {
  return this.genericApiService.get<T>(`${TenancyEndpoints.GetTenancyById}/${id}`);
}

getTenancyByBuildingLevelId<T>(reqModel:any): Observable<HttpResponse<T>> {
  return this.genericApiService.post(TenancyEndpoints.getTenancyByBuildingLevelId, reqModel);
}

addTenancy<T>(reqModel:any): Observable<HttpResponse<T>> {
  return this.genericApiService.post(TenancyEndpoints.SaveTenancy, reqModel);
}

updateTenancy<T>(reqModel:any): Observable<HttpResponse<T>> {
  return this.genericApiService.post(TenancyEndpoints.UpdateTenancy, reqModel);
}

deleteTenancy<T>(TenancyId: number,SiteId: number): Observable<HttpResponse<T>> {
  return this.genericApiService.delete(`${TenancyEndpoints.DeleteTenancy}/${TenancyId}/${SiteId}`);
}

checkDeleteInactiveTenancys<T>(TenancyId: number): Observable<HttpResponse<T>> {
  return this.genericApiService.delete(`${TenancyEndpoints.checkDeleteInactiveTenancy}/${TenancyId}`);
}

getBuilding<T>(siteId: any,BuildingId:number): Observable<any>{  
  return this.genericApiService.get<T>(`${TenancyEndpoints.GetBuilding}/${siteId}/${BuildingId}`);        
}

getLevel<T>(reqModel:any): Observable<HttpResponse<T>> {
  return this.genericApiService.post(TenancyEndpoints.GetLevel, reqModel);
}
getTenancy<T>(reqModel:any):Observable<HttpResponse<T>>{
  return this.genericApiService.post(TenancyEndpoints.GetTenancyList, reqModel);
}
getAllLeveldropdown<T>(siteId: any): Observable<any>{  
  return this.genericApiService.get<T>(`${TenancyEndpoints.GetAllLeveldropdown}/${siteId}`);        
}
GetAllTenancyBySiteLevel<T>(reqModel:any): Observable<HttpResponse<T>> {
  return this.genericApiService.post(TenancyEndpoints.GetAllTenancyBySiteBuildingLevel, reqModel);
}

getAllLevelList<T>(reqModel:any): Observable<HttpResponse<T>> {
  return this.genericApiService.post(TenancyEndpoints.GetAllLevelBySite, reqModel);
}

getAllTenancyByLevelSite<T>(reqModel:any): Observable<HttpResponse<T>> {
  return this.genericApiService.post(TenancyEndpoints.GetAllTenancyBySiteLevel, reqModel);
}

}
